import {
  LOGIN,
  REGISTER,
  LOGOUT,
  EDIT_PASSWORD,
} from "../actions/auth-actions";
import { ApiRequestState } from "../../types/state-management";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const authReducer = (state = initialState, action: any): ApiRequestState => {
  switch (action.type) {
    case LOGIN.REQUEST:
    case REGISTER.REQUEST:
    case LOGOUT.REQUEST:
    case EDIT_PASSWORD.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case LOGIN.SUCCESS:
    case REGISTER.SUCCESS:
    case EDIT_PASSWORD.SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case LOGOUT.SUCCESS:
      return {
        ...state,
        loading: false,
        data: null,
        error: null,
      };
    case LOGIN.FAILURE:
    case REGISTER.FAILURE:
    case LOGOUT.FAILURE:
    case EDIT_PASSWORD.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export { authReducer };
